// import React from 'react'
// import 'react-loading-skeleton/dist/skeleton.css';
// import "../skeleton/skeleton.css"
 

// const Skeleton=({width, height, variant})=> {
//     const style={
//         width,
//         height,
//     }
//   return (
//     <span className={`skeleton ${variant}`} style={style}></span>
//   )
// }

// export default Skeleton;
import React from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

const SkeletonPackage = () => {
   
  return (
    <div className="mainBorder mb-4">
      <div className="d-flex flex-row" style={{ width: '100%' }}>
        {/* Skeleton for Image with Animated Background */}
        <Skeleton
          height={200}
          width={380}
          className="skeleton-animation"
          style={{ backgroundColor: 'rgba(240, 240, 240, 1)' }}
        />

        {/* Skeleton for Text Content with Animated Background */}
        <div className="d-flex flex-column mt-2 border-top me-3 ps-3 pe-3 rounded-3 border-end border-2">
          {/* Title Skeleton */}
          <Skeleton height={30} width={200} className="skeleton-animation" />

          {/* Location Skeleton */}
          <Skeleton height={20} width={150} className="mt-3 mb-3 skeleton-animation" />

          {/* Features Skeleton */}
          <Skeleton height={20} width={250} className="mt-2 mb-2 skeleton-animation" />

          {/* Facilities Skeleton */}
          <Skeleton height={20} width={150} className="mt-3 mb-3 skeleton-animation" />

          {/* Price and Button Skeleton */}
          <div className="d-flex flex-row justify-content-between border-top pt-2 border-2">
            {/* Duration Skeleton */}
            <Skeleton height={20} width={80} className="skeleton-animation" />
            {/* Price and Button */}
            <div className="d-flex flex-row gap-3">
              <Skeleton height={20} width={80} className="skeleton-animation" />
              <Skeleton height={40} width={100} className="skeleton-animation" />
            </div>
          </div>
        </div>
      </div>

      {/* Skeleton for Bottom Section with More Places */}
      <div
        className="d-flex flex-row justify-content-between rounded-bottom-4 ms-2"
        style={{
          width: '97%',
          background: 'rgba(229, 229, 229, 1)',
          boxShadow: '8px 10px 23.1px 0px rgba(0, 0, 0, 0.03)',
          border: '1px solid rgba(255, 255, 255, 1)',
        }}
      >
        <div className="pt-1 ms-3">
          <Skeleton height={20} width={200} className="skeleton-animation" />
        </div>
        <div className="pt-2">
          <Skeleton height={20} width={80} className="skeleton-animation" />
        </div>
      </div>
    </div>
  );
};

export default SkeletonPackage;
